import { EventTypeRecord } from '@/apis/eventTypes';

// Meeting - Volunteer (18) => Meeting (4)
// Social - Volunteer (19) => Social (17)
// Training - Volunteer (20) => Training (13)
export function migrateRedundantEventTypes(items: EventTypeRecord[]): EventTypeRecord[] {
  const migrationMap: Record<number, EventTypeRecord> = {
    18: { id: 4, label: 'Meeting' },
    19: { id: 17, label: 'Social' },
    20: { id: 13, label: 'Training' },
  };

  return items.reduce((acc: EventTypeRecord[], item) => {
    const migratedItem = migrationMap[item.id];

    // If item doesn't need migration, add it to result
    if (!migratedItem) {
      return [...acc, item];
    }

    // Skip if target ID already exists in accumulator or original array
    const itemAlreadyExists =
      acc.some((i) => i.id === migratedItem.id) || items.some((i) => i.id === migratedItem.id);

    if (!itemAlreadyExists) {
      return [...acc, migratedItem];
    }

    return acc;
  }, []);
}

export function migrateRedundantEventTypeIds(items: number[]): number[] {
  const migrationMap: Record<number, number> = {
    18: 4,
    19: 17,
    20: 13,
  };

  return items.reduce((acc: number[], item) => {
    const migratedItem = migrationMap[item];

    // If item doesn't need migration, add it to result
    if (!migratedItem) {
      return [...acc, item];
    }

    // Skip if target ID already exists in accumulator or original array
    const itemAlreadyExists =
      acc.some((i) => i === migratedItem) || items.some((i) => i === migratedItem);

    if (!itemAlreadyExists) {
      return [...acc, migratedItem];
    }

    return acc;
  }, []);
}
